(() => {
  const body = document.body;
  const drawer = document.querySelector('#CartDrawer');
  const openButtons = document.querySelectorAll('.cart-toggle');
  const closeButtons = document.querySelectorAll('[data-cart-close]');
  const trilogyHandles = ['alba-serrano','veinte-minutos','lo-que-dejamos-atras'];
  const packHandle = 'la-version-de-los-hechos-trilogia';
  const coverMap = {
    'alba-serrano': '/cdn/shop/t/2/assets/01_ALBA_SERRANO_PORTADA.png',
    'veinte-minutos': '/cdn/shop/t/2/assets/02_VEINTE_MINUTOS_PORTADA.png',
    'lo-que-dejamos-atras': '/cdn/shop/t/2/assets/03_LO_QUE_DEJAMOS_ATRAS_PORTADA.png',
    'la-version-de-los-hechos-trilogia': '/cdn/shop/t/2/assets/01_ALBA_SERRANO_PORTADA.png'
  };
  const formatMoney = cents => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const escapeHtml = value => String(value || '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));

  const productData = async handle => fetch('/products/' + handle + '.js').then(r => r.ok ? r.json() : null).catch(() => null);

  const updateCart = async () => {
    if (!drawer) return;
    const cart = await fetch('/cart.js').then(r => r.json());
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const lines = document.querySelector('[data-cart-lines]');
    const footer = document.querySelector('[data-cart-footer]');
    if (!cart.item_count) {
      lines.innerHTML = '<div class="cart-empty"><p>Tu cesta está vacía.</p><p>La historia puede empezar por aquí.</p><a class="text-link" href="/pages/la-version-de-los-hechos">DESCUBRIR LA VERSIÓN DE LOS HECHOS →</a></div>';
      footer.hidden = true;
      return;
    }
    const enriched = await Promise.all(cart.items.map(async item => ({ item, product: await productData(item.handle) })));
    lines.innerHTML = enriched.map(({item, product}) => {
      const variant = product?.variants?.find(v => String(v.id) === String(item.variant_id)) || product?.variants?.[0];
      const compare = Number(variant?.compare_at_price || 0) * item.quantity;
      const current = Number(item.final_line_price || item.line_price || 0);
      const hasCompare = compare > current;
      const image = coverMap[item.handle] || item.featured_image?.url || item.image || '';
      const prices = hasCompare ? '<span class="cart-price"><s>' + formatMoney(compare) + '</s><strong>' + formatMoney(current) + '</strong></span>' : '<strong>' + formatMoney(current) + '</strong>';
      return '<article class="cart-line"><img src="' + escapeHtml(image) + '" alt="Portada de ' + escapeHtml(item.product_title) + '"><div><h3>' + escapeHtml(item.product_title) + '</h3><p>Ebook · EPUB + PDF</p>' + prices + '<button type="button" data-remove-key="' + escapeHtml(item.key) + '">ELIMINAR</button></div></article>';
    }).join('');
    const handles = cart.items.map(item => item.handle);
    const individualCount = handles.filter(handle => trilogyHandles.includes(handle)).length;
    if (individualCount > 0 && individualCount < 3 && !handles.includes(packHandle)) {
      lines.insertAdjacentHTML('beforeend','<aside class="cart-upsell" aria-label="Recomendación"><strong>Completa la trilogía y ahorra 3,98 €</strong><p>Consigue los tres libros por 13,99 €.</p><a class="button button-light button-full" href="/products/' + packHandle + '">VER LA TRILOGÍA</a></aside>');
    }
    document.querySelector('[data-cart-total]').textContent = formatMoney(cart.total_price);
    footer.hidden = false;
  };

  const openCart = async () => { await updateCart(); if (!drawer) return; drawer.setAttribute('aria-hidden','false'); body.classList.add('drawer-open'); openButtons.forEach(b => b.setAttribute('aria-expanded','true')); drawer.querySelector('[data-cart-close]')?.focus(); };
  const closeCart = () => { if (!drawer) return; drawer.setAttribute('aria-hidden','true'); body.classList.remove('drawer-open'); openButtons.forEach(b => b.setAttribute('aria-expanded','false')); };
  openButtons.forEach(b => b.addEventListener('click', openCart));
  closeButtons.forEach(b => b.addEventListener('click', closeCart));

  drawer?.addEventListener('click', async e => {
    const key = e.target.dataset.removeKey;
    if (!key) return;
    await fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})});
    await updateCart();
  });

  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const button = e.submitter || form.querySelector('[type="submit"]');
    const buyNow = Boolean(button?.dataset.buyNow);
    if (button) { button.disabled = true; button.textContent = 'AÑADIENDO…'; }
    const response = await fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
    if (!response.ok) { if (button) { button.disabled=false; button.textContent=button.dataset.label || 'AÑADIR A LA CESTA'; } return; }
    if (buyNow) { window.location.href = '/checkout'; return; }
    if (button) { button.disabled=false; button.textContent=button.dataset.label || 'AÑADIR A LA CESTA'; }
    await openCart();
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    const primary = form.querySelector('[type="submit"]');
    if (!primary) return;
    primary.textContent = 'AÑADIR A LA CESTA';
    primary.dataset.label = 'AÑADIR A LA CESTA';
    if (!form.querySelector('[data-buy-now]')) {
      const buy = document.createElement('button');
      buy.type = 'submit'; buy.className = 'button button-light'; buy.dataset.buyNow = 'true'; buy.dataset.label = 'COMPRAR AHORA'; buy.textContent = 'COMPRAR AHORA';
      form.appendChild(buy);
    }
    form.classList.add('product-actions');
  });

  const addQuickBuy = async (link, handle) => {
    if (!link || link.parentElement.querySelector('.quick-buy')) return;
    const product = await productData(handle);
    const variant = product?.variants?.find(v => v.available) || product?.variants?.[0];
    if (!variant) return;
    const form = document.createElement('form');
    form.method = 'post'; form.action = '/cart/add'; form.className = 'quick-buy';
    form.innerHTML = '<input type="hidden" name="id" value="' + variant.id + '"><button class="button button-dark" type="submit" data-label="AÑADIR A LA CESTA">AÑADIR A LA CESTA</button>';
    link.insertAdjacentElement('beforebegin', form);
  };
  document.querySelectorAll('.book-row').forEach(row => {
    const link = row.querySelector('a[href*="/products/"]');
    const handle = link?.getAttribute('href')?.split('/products/')[1]?.split(/[?#]/)[0];
    if (handle) addQuickBuy(link, handle);
  });
  const packLink = document.querySelector('.pack-section a[href*="/products/' + packHandle + '"]');
  if (packLink) addQuickBuy(packLink, packHandle);

  const pathHandle = location.pathname.includes('/products/') ? location.pathname.split('/products/')[1].split('/')[0] : null;
  if (pathHandle) {
    const nav = document.createElement('nav');
    nav.className = 'book-switcher'; nav.setAttribute('aria-label','Moverse entre los libros');
    nav.innerHTML = '<a href="/products/alba-serrano">LIBRO I</a><a href="/products/veinte-minutos">LIBRO II</a><a href="/products/lo-que-dejamos-atras">LIBRO III</a><a href="/products/' + packHandle + '">TRILOGÍA</a>';
    nav.querySelectorAll('a').forEach(a => { if (a.getAttribute('href').endsWith('/' + pathHandle)) a.setAttribute('aria-current','page'); });
    document.querySelector('[data-product-hero]')?.insertAdjacentElement('afterend', nav);
  }

  if (pathHandle === packHandle) {
    const links = ['/products/alba-serrano','/products/veinte-minutos','/products/lo-que-dejamos-atras'];
    document.querySelectorAll('.story-books article').forEach((article,index) => {
      article.tabIndex = 0; article.setAttribute('role','link'); article.setAttribute('aria-label','Ver ' + (article.querySelector('h2')?.textContent || 'libro'));
      article.addEventListener('click', e => { if (!e.target.closest('a,button')) location.href = links[index]; });
      article.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); location.href = links[index]; } });
      article.insertAdjacentHTML('beforeend','<a class="text-link" href="' + links[index] + '">VER LIBRO →</a>');
    });
    (async () => {
      if (!document.querySelector('#AlbaTeaser')) {
        const html = await fetch('/').then(r => r.text());
        const doc = new DOMParser().parseFromString(html,'text/html');
        const dialog = doc.querySelector('#AlbaTeaser');
        if (dialog) document.body.appendChild(document.importNode(dialog,true));
      }
      const info = document.querySelector('.product-info');
      if (info && !info.querySelector('[data-modal-open]')) info.insertAdjacentHTML('beforeend','<button class="text-link trilogy-read" type="button" data-modal-open="AlbaTeaser">LEER ANTES DE EMPEZAR →</button>');
    })();
  }

  const menuButton = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('#mobile-menu');
  menuButton?.addEventListener('click', () => { const expanded=menuButton.getAttribute('aria-expanded')==='true'; menuButton.setAttribute('aria-expanded',String(!expanded)); mobileMenu.hidden=expanded; });
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) document.querySelector('#' + opener.dataset.modalOpen)?.showModal();
    const closer = e.target.closest('[data-modal-close]');
    if (closer) closer.closest('dialog')?.close();
  });
  const sticky = document.querySelector('[data-sticky-buy]');
  const hero = document.querySelector('[data-product-hero]');
  if(sticky && hero && 'IntersectionObserver' in window){new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting),{threshold:0}).observe(hero);}

  const style = document.createElement('style');
  style.textContent = '.product-actions{display:flex;flex-wrap:wrap;gap:12px}.product-actions .button{margin:0}.quick-buy{margin:18px 0 10px}.quick-buy .button{width:100%}.book-switcher{max-width:1320px;margin:0 auto 50px;padding:0 32px;display:flex;flex-wrap:wrap;gap:10px;justify-content:center}.book-switcher a{padding:10px 14px;border:1px solid currentColor;font-size:.78rem;letter-spacing:.08em;text-decoration:none}.book-switcher a[aria-current="page"]{background:#141414;color:#f4f1ea}.story-books article[role="link"]{cursor:pointer}.story-books article:focus-visible{outline:2px solid #141414;outline-offset:5px}.story-books img{aspect-ratio:993/1584!important;width:100%!important;height:auto!important;object-fit:cover!important}.cart-price{display:flex;align-items:baseline;gap:9px}.cart-price s{color:#777;font-size:.85rem}.cart-upsell{margin-top:20px;padding:20px;background:#e9e1d5;color:#141414}.cart-upsell p{margin:6px 0 14px}.trilogy-read{display:block;margin-top:22px}.desktop-nav a{font-size:max(13px,.72rem)}@media(max-width:749px){.product-actions{display:grid}.product-actions .button{width:100%;min-width:0}.book-switcher{padding:0 18px}.book-switcher a{flex:1;text-align:center}}';
  document.head.appendChild(style);
})();